import { storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import Blog from "../../../../V2/Cards/Content/Blog"

import { storyblokLinkToYocoLink } from "@utils/storyblok"

const StoryblokBlogCard = ({
  blok,
  mobileGridOrder,
  isSliderChild,
}: Storyblok.BlokProps<Storyblok.BlogCard>) => {
  return (
    <Blog
      overrideTextColor={blok.overrideTextColor}
      imageAlt={blok.image.alt}
      imageUrl={blok.image.filename}
      title={blok.title}
      body={blok.body}
      date={blok.date}
      ctaText={blok.ctaText}
      ctaUrl={storyblokLinkToYocoLink(blok.ctaUrl)}
      ctaColor={blok.ctaColor}
      superscriptText={blok.superscriptText}
      footerTitle={blok.footerTitle}
      footerSubtitle={blok.footerSubtitle}
      mobileGridOrder={mobileGridOrder}
      isSliderChild={isSliderChild}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokBlogCard
